import React from 'react';
import {monthNow} from '../../../assets/utils/dateUtils';
import {useBillingListQuery} from '../../../redux/userBillingApi';
import {useTranslation} from 'react-i18next';
import PreLoaderComponent from '../../../assets/Animations/PreLoaderComponent/PreLoaderComponent';
import s from './SumBonusBlock.module.css';

const SumBonusBlock: React.FC = () => {
	const {t} = useTranslation();
	const {data, isLoading} = useBillingListQuery(monthNow());

	if (isLoading) {
		return <PreLoaderComponent type={'circle'} size={'big'} />;
	}

	if (!data || !data.currencies || data.currencies.length === 0) {
		return null;
	}

	// Находим гривневый счет
	const uahAccount = data.currencies.find(
		(account) => account.currency === 'uah',
	);

	return (
		<div className={s.sumBonusBlock}>
			<div className={s.bonusTop}>
				<div className={s.bonusIcon}></div>
				<div className={s.bonusLabel}>{t('Мій бонусний рахунок')}</div>
			</div>
			<div className={s.bonusSum}>
				{uahAccount ? uahAccount.money : '0'}
				<span></span>
			</div>
		</div>
	);
};

export default SumBonusBlock;
